const DarkTheme =   {
    palette: {
      mode: "dark",
    },
  };

  export default DarkTheme;